import { DataFilter, DataFilterValidationError } from '../../../interface';
import { And, Not, Rule, StringEquals } from '@vendasta/automata';
import { ANY_STAGE, PipelineSelectorComponent } from './pipeline-selector/pipeline-selector.component';
import { PipelineSelectorDisplayService } from './pipeline-selector/pipeline-selector-display.service';
import { StandardIds } from '@galaxy/crm/static';

const PIPELINE_RULE = `{.opportunity_data['${StandardIds.OpportunityPipelineID}']}`;
const STAGE_RULE = `{.opportunity_data['${StandardIds.OpportunityCalculatedStageID}']}`;
// This key is not used for comparisons since this filter is composed of a multi-valued AND rule
export const PIPELINE_PARENT_RULE_NAME = `${PIPELINE_RULE}${STAGE_RULE}`;
export const PIPELINE_STAGE_CHILD_RULES = [
  new StringEquals(`{.opportunity_data['${StandardIds.OpportunityPipelineID}']}`, '', ''),
  new StringEquals(`{.opportunity_data['${StandardIds.OpportunityCalculatedStageID}']}`, '', ''),
];
export class PipelineStageComponent implements DataFilter {
  rules: Rule[] = [new And(PIPELINE_STAGE_CHILD_RULES), new Not(new And(PIPELINE_STAGE_CHILD_RULES))];

  dataEntryComponent = PipelineSelectorComponent;
  displayService = PipelineSelectorDisplayService;
  comparisonLabels = [
    'AUTOMATIONS.EDITOR.FILTERS.COMPARISON.EQUALS',
    'AUTOMATIONS.EDITOR.FILTERS.COMPARISON.NOT_EQUALS',
  ];
  label = 'AUTOMATIONS.EDITOR.FILTERS.OPPORTUNITY_DATA.DATA_LABELS.PIPELINE_AND_STAGE';
  validationError: DataFilterValidationError | undefined;
  updateComponentInstanceFn = (component: PipelineSelectorComponent) => {
    component.includeAnyStageOption = true;
    component.defaultStageSelection = ANY_STAGE;
  };
}
